import React from "react";
import LoginScreen from "./Login";
import OTPScreen from "./OTP";
import { useSelector } from "react-redux";

const AuthPage = () => {
  const { currentStep } = useSelector((state) => state.auth);

  return <div>{currentStep === "login" ? <LoginScreen /> : <OTPScreen />}</div>;
};

export default AuthPage;
